import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { loadLatestBoardSummaryReport } from "../../redux/modules/boardSummaryReports";

const BoardSummaryDropdown = ({
  latestReport,
  loading,
  errors,
  loadLatestBoardSummaryReport,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Load the latest board summary report when component mounts
    loadLatestBoardSummaryReport();
  }, [loadLatestBoardSummaryReport]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  // Don't render dropdown if no report found, loading, or if there's an error
  if (
    !loading &&
    (!latestReport ||
      latestReport.message === "No report found" ||
      errors.length > 0)
  ) {
    return null;
  }

  return (
    <div className="dropdown" style={{ position: "relative" }}>
      <button
        className="btn btn-link text-decoration-none"
        onClick={toggleDropdown}
        style={{
          color: "#001F38",
          border: "1px solid #efefef",
          borderRadius: "6px",
          background: "#c6fbff",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "8px 16px",
          fontWeight: "500",
          boxShadow: "0 2px 4px rgba(0,31,56,0.2)",
          transition: "all 0.2s ease",
        }}
      >
        Board & Executive Summary Report
        <i
          className={`fa ${isOpen ? "fa-caret-up" : "fa-caret-down"}`}
          style={{ fontSize: "12px" }}
        />
      </button>

      {isOpen && (
        <div
          className="dropdown-menu show"
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            minWidth: "300px",
            maxWidth: "400px",
            maxHeight: "400px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "4px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            zIndex: 1000,
            padding: "15px",
            overflowY: "auto",
          }}
        >
          {loading && (
            <div className="text-center">
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <p className="mt-2 mb-0">Loading report...</p>
            </div>
          )}

          {errors.length > 0 && (
            <div className="alert alert-danger">
              <small>Error loading report: {errors.join(", ")}</small>
            </div>
          )}

          {latestReport && !loading && (
            <>
              <div className="text-center mb-3">
                <h6 className="mb-1" style={{ fontWeight: "bold" }}>
                  Board Summary Report
                </h6>
                <small className="text-muted">
                  {formatDate(latestReport.date)}
                </small>
              </div>

              {latestReport.companies && latestReport.companies.length > 0 ? (
                <div>
                  {latestReport.companies.map((company, index) => (
                    <div
                      key={company.id || index}
                      className="d-flex justify-content-between align-items-center mb-2"
                      style={{
                        gap: "24px",
                        padding: "8px 0",
                        borderBottom:
                          index < latestReport.companies.length - 1
                            ? "1px solid #eee"
                            : "none",
                      }}
                    >
                      <span
                        style={{
                          maxWidth: "200px",
                          fontSize: "14px",
                          whiteSpace: "wrap",
                          wordBreak: "break-word",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {company.name}
                      </span>
                      <button
                        className="btn btn-sm btn-outline-primary"
                        style={{ fontSize: "12px", padding: "4px 8px" }}
                        onClick={() => {
                          if (company.url && company.url !== "#") {
                            // Handle relative URLs by prepending current host
                            const fullUrl = company.url.startsWith("http")
                              ? company.url
                              : `${window.location.origin}${company.url}`;
                            window.open(fullUrl, "_blank");
                          } else {
                            console.log(`Download for ${company.name}`);
                          }
                        }}
                      >
                        Download PDF
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center text-muted">
                  <small>No companies found in this report</small>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* Overlay to close dropdown when clicking outside */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,
          }}
          onClick={toggleDropdown}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  latestReport: state.boardSummaryReports.latestReport,
  loading: state.boardSummaryReports.loading,
  errors: state.boardSummaryReports.errors,
});

const mapDispatchToProps = {
  loadLatestBoardSummaryReport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BoardSummaryDropdown);
